<template>
  <div>
    <!-- phones get a two-column table that sorts, the rest of each player under a tap; desktop keeps the full table -->
    <PlayerTable
      class="md:hidden"
      kind="cards"
      :match="match"
      :homeList="homeList"
      :awayList="awayList"
      :sortValue="sortValue"
      :homeInjured="popOverData.home_team.injured_players || []"
      :homeSuspended="popOverData.home_team.suspended_players || []"
      :awayInjured="popOverData.away_team.injured_players || []"
      :awaySuspended="popOverData.away_team.suspended_players || []"
      :playerProps="playerProps"
      :slipMatch="slipMatch"
      :lineupConfirmed="lineupConfirmed"
    />
    <div class="player-tables hidden md:block">
    <div
      class="mt-3 border-gray-100 border-[1px]"
      v-if="
        popOverData.home_team.cards_fouls &&
        popOverData.home_team.cards_fouls[
          getTimeFrameDropdown('cards_fouls')
        ] &&
        popOverData.home_team.cards_fouls[getTimeFrameDropdown('cards_fouls')]
          .length > 0
      "
      :class="{ 'only-5-toggle': cardsHomeShort }"
    >
      <div
        class="flex p-2 bg-[#ffd5d5] rounded-t-lg border-b-[1px] border-gray-400 font-semibold text-xs select-none"
      >
        <h3
          class="w-36 flex-none min-w-0 pr-2 uppercase text-sm text-black text-shadow-sm flex items-center"
        >
          <img :src="match.home_team.logo" class="cursor-pointer w-4 h-auto mr-1" @click.stop="openTeam(match.home_team)" title="Team page" />
          {{ popOverData.home_team.name }}
        </h3>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('appearances')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Appearances">Apps</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Appearances</li>
            </ul>
            <span v-if="homeSort.key === 'appearances'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('avg_minutes')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Average Mins per game">Mins</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Minutes</li>
            </ul>
            <span v-if="homeSort.key === 'avg_minutes'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('yellow_cards_all_comps')"
        >
          <span class="group relative inline-block">
            <svg
              class="inline-block drop-shadow-md"
              width="12"
              height="16"
              viewBox="0 0 8 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 1C0 0.447715 0.447715 0 1 0L7 0C7.55228 0 8 0.447715 8 1V10C8 10.5523 7.55228 11 7 11H1C0.447715 11 0 10.5523 0 10L0 1Z"
                fill="#FFEC3E"
              />
            </svg>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Yellow Cards</li>
            </ul>
            <span
              v-if="homeSort.key === 'yellow_cards_all_comps'"
              class="ml-1"
              >{{ homeSort.asc ? "▲" : "▼" }}</span
            >
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('red_cards_all_comps')"
        >
          <span class="group relative inline-block">
            <svg
              class="inline-block drop-shadow-md"
              width="12"
              height="16"
              viewBox="0 0 8 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M-3.8147e-06 1C-3.8147e-06 0.447715 0.447711 0 0.999996 0L7 0C7.55228 0 8 0.447715 8 1V10C8 10.5523 7.55228 11 7 11H0.999996C0.447711 11 -3.8147e-06 10.5523 -3.8147e-06 10L-3.8147e-06 1Z"
                fill="#CF1818"
              />
            </svg>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Red Cards</li>
            </ul>
            <span v-if="homeSort.key === 'red_cards_all_comps'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortHome('avg_fouls')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Fouls/g">Fouls/g</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Fouls p90</li>
            </ul>
            <span v-if="homeSort.key === 'avg_fouls'" class="ml-1">{{
              homeSort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          v-if="hasHomeProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of being booked"
          @click="!propsLocked && sortHome('prop|card|')"
        >
          Booked<span v-if="homeSort.key === 'prop|card|'" class="ml-1">{{ homeSort.asc ? "▲" : "▼" }}</span>
        </div>
        <div
          v-if="hasHomeProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 1+ foul"
          @click="!propsLocked && sortHome('prop|fouls|1+')"
        >
          Fouls 1+<span v-if="homeSort.key === 'prop|fouls|1+'" class="ml-1">{{ homeSort.asc ? "▲" : "▼" }}</span>
        </div>
        <div
          v-if="hasHomeProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 1+ tackle"
          @click="!propsLocked && sortHome('prop|tackles|1+')"
        >
          Tackles 1+<span v-if="homeSort.key === 'prop|tackles|1+'" class="ml-1">{{ homeSort.asc ? "▲" : "▼" }}</span>
        </div>
      </div>
      <div
        class="text-xxs only-5-item p-2"
        v-for="(item, key) in sortedHome.slice(0, homeVisible)"
        :key="key"
        :class="key % 2 === 0 ? 'bg-[#FAEBEA]' : 'bg-[#ffd5d5]'"
      >
        <p
          class="flex"
          v-if="
            ('injured_players' in popOverData.home_team &&
              popOverData.home_team.injured_players.includes(item.name)) ||
            popOverData.home_team.suspended_players.includes(item.name)
          "
        >
          <span class="w-36 flex-none min-w-0 pr-2 leading-tight text-red-500"
            >{{ item.name }}
            <img
              v-if="popOverData.home_team.injured_players.includes(item.name)"
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/red-cross.png"
              title="Injured"
            />
            <img
              v-if="
                'suspended_players' in popOverData.home_team &&
                popOverData.home_team.suspended_players.includes(item.name)
              "
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/yellowred.png"
              title="Suspended"
            />
          </span>
          <span class="flex-1 text-center text-red-500">{{
            item.appearances
          }}</span>
          <span class="flex-1 text-center text-red-500">{{
            item.avg_minutes
          }}</span>
          <span class="flex-1 text-center text-red-500">{{
            item.yellow_cards_all_comps
          }}</span>
          <!-- <span class="flex-1 text-center text-red-500">-</span> -->
          <span class="flex-1 text-center text-red-500">{{
            item.red_cards_all_comps
          }}</span>
          <span class="flex-1 text-center text-red-500">{{
            item.avg_fouls
          }}</span>
          <template v-if="hasHomeProps">
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="card" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="fouls" line="1+" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="tackles" line="1+" :slipMatch="slipMatch" />
          </template>
        </p>
        <p class="flex" v-else>
          <span class="w-36 flex-none min-w-0 pr-2 leading-tight text-gray-700">{{ item.name }}</span>
          <span class="flex-1 text-center">{{ item.appearances }}</span>
          <span class="flex-1 text-center">{{ item.avg_minutes }}</span>
          <span class="flex-1 text-center">{{
            item.yellow_cards_all_comps
          }}</span>
          <!-- <span
                              class="flex-1 text-center"
                              v-if="item.card_prediction"
                              >{{ item.card_prediction }}
                            </span>
                            <span class="flex-1 text-center" v-else>-</span> -->
          <span class="flex-1 text-center">{{ item.red_cards_all_comps }}</span>
          <span class="flex-1 text-center">{{ item.avg_fouls }}</span>
          <template v-if="hasHomeProps">
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="card" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="fouls" line="1+" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="home_team" :item="item" market="tackles" line="1+" :slipMatch="slipMatch" />
          </template>
        </p>
      </div>
      <div
        class="flex items-center justify-center py-2 border-t-[1px] border-gray-400 rounded-b-lg bg-[#ffd4d4]"
        v-if="sortedHome.length > 5"
      >
        <button
          class="text-gray-500 uppercase underline text-xxs"
          @click="toggleShowMore('home')"
        >
          <template v-if="homeVisible < sortedHome.length">Show more</template>
          <template v-else>Show less</template>
        </button>
      </div>
    </div>
    <div v-else class="flex items-start align-top space-x-4">
      <span class="w-full align-bottom py-2 text-center text-gray-500 text-xs">
        No recent home team cards
      </span>
    </div>

    <div
      class="my-5 border-gray-100 rounded-lg border-[1px]"
      v-if="
        popOverData.away_team.cards_fouls &&
        popOverData.away_team.cards_fouls[
          getTimeFrameDropdown('cards_fouls')
        ] &&
        popOverData.away_team.cards_fouls[getTimeFrameDropdown('cards_fouls')]
          .length > 0
      "
      :class="{ 'only-5-toggle': cardsAwayShort }"
    >
      <div
        class="flex p-2 bg-[#dcdcff] border-b-[1px] border-gray-400 rounded-t-xl font-semibold text-xs select-none"
      >
        <h3
          class="w-36 flex-none min-w-0 pr-2 uppercase text-sm text-black text-shadow-sm flex items-center"
        >
          <img :src="match.away_team.logo" class="cursor-pointer w-4 h-auto mr-1" @click.stop="openTeam(match.away_team)" title="Team page" />
          {{ popOverData.away_team.name }}
        </h3>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('appearances')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Appearances">Apps</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Appearances</li>
            </ul>
            <span v-if="awaySort.key === 'appearances'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('avg_minutes')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Average Mins per game">Mins</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Minutes</li>
            </ul>
            <span v-if="awaySort.key === 'avg_minutes'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('yellow_cards_all_comps')"
        >
          <span class="group relative inline-block">
            <svg
              class="inline-block drop-shadow-md"
              width="12"
              height="16"
              viewBox="0 0 8 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 1C0 0.447715 0.447715 0 1 0L7 0C7.55228 0 8 0.447715 8 1V10C8 10.5523 7.55228 11 7 11H1C0.447715 11 0 10.5523 0 10L0 1Z"
                fill="#FFEC3E"
              />
            </svg>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Yellow Cards</li>
            </ul>
            <span
              v-if="awaySort.key === 'yellow_cards_all_comps'"
              class="ml-1"
              >{{ awaySort.asc ? "▲" : "▼" }}</span
            >
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('red_cards_all_comps')"
        >
          <span class="group relative inline-block">
            <svg
              class="inline-block drop-shadow-md"
              width="12"
              height="16"
              viewBox="0 0 8 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M-3.8147e-06 1C-3.8147e-06 0.447715 0.447711 0 0.999996 0L7 0C7.55228 0 8 0.447715 8 1V10C8 10.5523 7.55228 11 7 11H0.999996C0.447711 11 -3.8147e-06 10.5523 -3.8147e-06 10L-3.8147e-06 1Z"
                fill="#CF1818"
              />
            </svg>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Red Cards</li>
            </ul>
            <span v-if="awaySort.key === 'red_cards_all_comps'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          class="flex-1 text-center cursor-pointer"
          @click="sortAway('avg_fouls')"
        >
          <span class="group relative inline-block">
            <span class="inline-block leading-tight px-0.5" title="Fouls/g">Fouls/g</span>
            <ul
              class="absolute right-0 p-1 border text-left text-[10px] w-48 z-20 bottom-full bg-white hidden group-hover:block"
            >
              <li>Avg. Fouls p90</li>
            </ul>
            <span v-if="awaySort.key === 'avg_fouls'" class="ml-1">{{
              awaySort.asc ? "▲" : "▼"
            }}</span>
          </span>
        </div>
        <div
          v-if="hasAwayProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of being booked"
          @click="!propsLocked && sortAway('prop|card|')"
        >
          Booked<span v-if="awaySort.key === 'prop|card|'" class="ml-1">{{ awaySort.asc ? "▲" : "▼" }}</span>
        </div>
        <div
          v-if="hasAwayProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 1+ foul"
          @click="!propsLocked && sortAway('prop|fouls|1+')"
        >
          Fouls 1+<span v-if="awaySort.key === 'prop|fouls|1+'" class="ml-1">{{ awaySort.asc ? "▲" : "▼" }}</span>
        </div>
        <div
          v-if="hasAwayProps"
          class="flex-1 text-center px-0.5 leading-tight"
          :class="{ 'cursor-pointer': !propsLocked }"
          title="Our chance of 1+ tackle"
          @click="!propsLocked && sortAway('prop|tackles|1+')"
        >
          Tackles 1+<span v-if="awaySort.key === 'prop|tackles|1+'" class="ml-1">{{ awaySort.asc ? "▲" : "▼" }}</span>
        </div>
      </div>
      <div
        class="text-xxs only-5-item p-2"
        v-for="(item, key) in sortedAway.slice(0, awayVisible)"
        :key="key"
        :class="key % 2 === 0 ? 'bg-[#F5F5FE]' : 'bg-[#dcdcff]'"
      >
        <p
          class="flex"
          v-if="
            ('injured_players' in popOverData.away_team &&
              popOverData.away_team.injured_players.includes(item.name)) ||
            popOverData.away_team.suspended_players.includes(item.name)
          "
        >
          <span class="w-36 flex-none min-w-0 pr-2 leading-tight text-red-500"
            >{{ item.name }}
            <img
              v-if="popOverData.away_team.injured_players.includes(item.name)"
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/red-cross.png"
              title="Injured"
            />
            <img
              v-if="
                'suspended_players' in popOverData.away_team &&
                popOverData.away_team.suspended_players.includes(item.name)
              "
              class="w-3 inline-block relative left-[2px]"
              src="@/assets/icons/yellowred.png"
              title="Suspended"
            />
          </span>
          <span class="flex-1 text-center text-red-500">{{
            item.appearances
          }}</span>
          <span class="flex-1 text-center text-red-500">{{
            item.avg_minutes
          }}</span>
          <span class="flex-1 text-center text-red-500">{{
            item.yellow_cards_all_comps
          }}</span>
          <!-- <span class="flex-1 text-center text-red-500">-</span> -->
          <span class="flex-1 text-center text-red-500">{{
            item.red_cards_all_comps
          }}</span>
          <span class="flex-1 text-center text-red-500">{{
            item.avg_fouls
          }}</span>
          <template v-if="hasAwayProps">
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="card" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="fouls" line="1+" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="tackles" line="1+" :slipMatch="slipMatch" />
          </template>
        </p>
        <p class="flex" v-else>
          <span class="w-36 flex-none min-w-0 pr-2 leading-tight text-gray-700">{{ item.name }}</span>
          <span class="flex-1 text-center">{{ item.appearances }}</span>
          <span class="flex-1 text-center">{{ item.avg_minutes }}</span>
          <span class="flex-1 text-center">{{
            item.yellow_cards_all_comps
          }}</span>
          <!-- <span
                              class="flex-1 text-center"
                              v-if="item.card_prediction"
                              >{{ item.card_prediction }}
                            </span>
                            <span class="flex-1 text-center" v-else>-</span> -->
          <span class="flex-1 text-center">{{ item.red_cards_all_comps }}</span>
          <span class="flex-1 text-center">{{ item.avg_fouls }}</span>
          <template v-if="hasAwayProps">
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="card" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="fouls" line="1+" :slipMatch="slipMatch" />
            <PropCell :playerProps="playerProps" side="away_team" :item="item" market="tackles" line="1+" :slipMatch="slipMatch" />
          </template>
        </p>
      </div>
      <div
        class="flex items-center justify-center py-2 border-t-[1px] border-gray-400 rounded-b-lg bg-[#d1d1ff]"
        v-if="sortedAway.length > 5"
      >
        <button
          class="text-gray-500 uppercase underline text-xxs"
          @click="toggleShowMore('away')"
        >
          <template v-if="awayVisible < sortedAway.length">Show more</template>
          <template v-else>Show less</template>
        </button>
      </div>
    </div>
    <div v-else class="flex items-start align-top space-x-4">
      <span class="w-full align-bottom py-2 text-center text-gray-500 text-xs">
        No recent away team cards
      </span>
    </div>
    </div>
  </div>
</template>

<script>
import PropCell from "./betslip/PropCell.vue";
import PlayerTable from "./betslip/PlayerTable.vue";
import { propP, propsLocked } from "./betslip/propValue";

import teamLinks from "@/teamLinks";
export default {
  mixins: [teamLinks],
  components: { PropCell, PlayerTable },
  props: {
    popOverData: { type: Object, required: true },
    match: { type: Object, required: true },
    timeFrameDropdowns: { type: Object, required: true },
    // bet slip: the match-info `props` block and {match_id, title, kickoff}
    playerProps: { type: Object, default: null },
    slipMatch: { type: Object, default: null },
    lineupConfirmed: { type: Boolean, default: false },
  },
  data() {
    return {
      homeSort: { key: "yellow_cards_all_comps", asc: false },
      awaySort: { key: "yellow_cards_all_comps", asc: false },
      homeVisible: 5,
      awayVisible: 5,
    };
  },
  computed: {
    hasHomeProps() {
      return !!(this.slipMatch && this.playerProps && (this.playerProps.home_team || []).length);
    },
    hasAwayProps() {
      return !!(this.slipMatch && this.playerProps && (this.playerProps.away_team || []).length);
    },
    homeList() {
      const key = this.getTimeFrameDropdown("cards_fouls");
      return (
        (this.popOverData.home_team.cards_fouls &&
          this.popOverData.home_team.cards_fouls[key]) ||
        []
      );
    },
    awayList() {
      const key = this.getTimeFrameDropdown("cards_fouls");
      return (
        (this.popOverData.away_team.cards_fouls &&
          this.popOverData.away_team.cards_fouls[key]) ||
        []
      );
    },
    sortedHome() {
      return this.sortList(this.homeList, this.homeSort, "home_team");
    },
    sortedAway() {
      return this.sortList(this.awayList, this.awaySort, "away_team");
    },
    propsLocked() {
      return propsLocked(this.$store, this.slipMatch);
    },
  },
  methods: {
    sortList(list, sort, side) {
      return [...list].sort((a, b) => {
        const av = this.sortValue(a, sort.key, side);
        const bv = this.sortValue(b, sort.key, side);
        return sort.asc ? av - bv : bv - av;
      });
    },
    // the number the column shows: our price for the bet columns (when on show), else the stat
    sortValue(item, key, side) {
      if (key.startsWith("prop|")) {
        const [, market, line] = key.split("|");
        const shown = (side === "home_team" ? this.hasHomeProps : this.hasAwayProps) && !this.propsLocked;
        return shown ? propP(this.playerProps, side, item, market, line) || -1 : -1;
      }
      return Number(item[key]) || 0;
    },
    toggleShowMore(type) {
      if (type === "home") {
        if (this.homeVisible < this.sortedHome.length) {
          this.homeVisible = Math.min(
            this.homeVisible + 5,
            this.sortedHome.length,
          );
        } else {
          this.homeVisible = 5;
        }
      } else {
        if (this.awayVisible < this.sortedAway.length) {
          this.awayVisible = Math.min(
            this.awayVisible + 5,
            this.sortedAway.length,
          );
        } else {
          this.awayVisible = 5;
        }
      }
    },
    getTimeFrameDropdown(type) {
      return this.timeFrameDropdowns[type];
    },
    sortHome(key) {
      if (this.homeSort.key === key) {
        this.homeSort.asc = !this.homeSort.asc;
      } else {
        this.homeSort.key = key;
        this.homeSort.asc = false; // descending on first click
      }
    },
    sortAway(key) {
      if (this.awaySort.key === key) {
        this.awaySort.asc = !this.awaySort.asc;
      } else {
        this.awaySort.key = key;
        this.awaySort.asc = false; // descending on first click
      }
    },
  },
};
</script>
